export interface FAQ {
  question: string;
  answerFile: string;
}

export interface LocalizedFAQ {
  'en'?: FAQ;
  'zh-TW'?: FAQ;
  'ko'?: FAQ;
  'ja'?: FAQ;
}

export const essentialFaqs: LocalizedFAQ[] = [
  {
    'en': {
      question: "Who should use Clarymind's Screen Time feature for better focus?",
      answerFile: "/content/faq/en/who.mdx"
    },
    'zh-TW': {
      question: "誰適合使用 Clarymind 的「提升專注」螢幕使用時間功能？",
      answerFile: "/content/faq/zh-TW/who.mdx"
    }
  },
  {
    'en': {
      question: "Who might not be a good fit for Clarymind?",
      answerFile: "/content/faq/en/who-does-not-fit.mdx"
    },
    'zh-TW': {
      question: "什麼樣的人可能不適合 Clarymind？",
      answerFile: "/content/faq/zh-TW/who-does-not-fit.mdx"
    }
  },
  {
    'en': {
      question: "How is Clarymind different from other focus apps?",
      answerFile: "/content/faq/en/difference-other-apps.mdx"
    },
    'zh-TW': {
      question: "Clarymind 和其他專注 App 有什麼不同？",
      answerFile: "/content/faq/zh-TW/difference-other-apps.mdx"
    }
  },
  {
    'en': {
      question: "How is Clarymind different from iPhone's built-in Screen Time feature?",
      answerFile: "/content/faq/en/difference-ios-screentime.mdx"
    },
    'zh-TW': {
      question: "iPhone 也有內建「螢幕使用時間」功能，Clarymind 和它有什麼差別？",
      answerFile: "/content/faq/zh-TW/difference-ios-screentime.mdx"
    }
  },
  {
    'zh-TW': {
      question: "如何預約線上導覽，了解 Clarymind 有哪些功能？",
      answerFile: "/content/faq/zh-TW/tour.mdx"
    }
  },
  {
    'en': {
      question: "How do I activate Pro features in the Clarymind app after subscribing?",
      answerFile: "/content/faq/en/how-to-activate.mdx"
    },
    'zh-TW': {
      question: "訂閱後，如何在 Clarymind App 啟用 Pro 功能？",
      answerFile: "/content/faq/zh-TW/how-to-activate.mdx"
    }
  },
  {
    'en': {
      question: "I don't want anyone to know which apps I use. Can I still use the focus feature?",
      answerFile: "/content/faq/en/privacy.mdx"
    },
    'zh-TW': {
      question: "我不想讓任何人知道我用了哪些 App，這樣我還可以使用提升專注功能嗎？",
      answerFile: "/content/faq/zh-TW/privacy.mdx"
    }
  },
  {
    'en': {
      question: "How do I subscribe/unsubscribe?",
      answerFile: "/content/faq/en/subscribe.mdx"
    },
    'zh-TW': {
      question: "如何訂閱／取消訂閱？",
      answerFile: "/content/faq/zh-TW/subscribe.mdx"
    }
  },
  {
    'en': {
      question: "Which platforms and operating systems does Clarymind currently support?",
      answerFile: "/content/faq/en/platform.mdx"
    },
    'zh-TW': {
      question: "Clarymind 目前支援哪些平台與作業系統？",
      answerFile: "/content/faq/zh-TW/platform.mdx"
    }
  },
];

export const faqs: LocalizedFAQ[] = [
  {
    'en': {
      question: "Why did we create Clarymind to help people reduce screen time?",
      answerFile: "/content/faq/en/why.mdx"
    },
    'zh-TW': {
      question: "為什麼我們打造 Clarymind，幫助人們提升專注？",
      answerFile: "/content/faq/zh-TW/why.mdx"
    }
  },
  {
    'en': {
      question: "How do social media affect me?",
      answerFile: "/content/faq/en/social-media.mdx"
    },
    'zh-TW': {
      question: "社群媒體會對我造成什麼影響？",
      answerFile: "/content/faq/zh-TW/social-media.mdx"
    }
  },
  {
    'en': {
      question: "How to deal with social media related anxiety?",
      answerFile: "/content/faq/en/anxiety.mdx"
    },
    'zh-TW': {
      question: "如何處理與社群媒體相關的焦慮？",
      answerFile: "/content/faq/zh-TW/anxiety.mdx"
    }
  },
  {
    'en': {
      question: "Besides app locking, Clarymind has many advanced features. Where can I find detailed introductions?",
      answerFile: "/content/faq/en/where-advanced.mdx"
    },
    'zh-TW': {
      question: "Clarymind 除了將 App 上鎖，還有很多其他進階功能，哪裡可以找到詳細介紹？",
      answerFile: "/content/faq/zh-TW/where-advanced.mdx"
    }
  },

  {
    'en': {
      question: "I regularly use another phone and iPad. Can I log in to multiple devices simultaneously?",
      answerFile: "/content/faq/en/multi-device.mdx"
    },
    'zh-TW': {
      question: "平時還有用別台手機和 iPad，可以同時登入多台裝置嗎？",
      answerFile: "/content/faq/zh-TW/multi-device.mdx"
    }
  },
  {
    'en': {
      question: "Does Clarymind currently have education or student plans?",
      answerFile: "/content/faq/en/education.mdx"
    },
    'zh-TW': {
      question: "Clarymind 現在有教育或學生方案嗎？",
      answerFile: "/content/faq/zh-TW/education.mdx"
    }
  },
  {
    'en': {
      question: "Questions about refunds",
      answerFile: "/content/faq/en/refund.mdx"
    },
    'zh-TW': {
      question: "退款相關問題",
      answerFile: "/content/faq/zh-TW/refund.mdx"
    }
  }
];